import { render, staticRenderFns } from "./zoneSideMenu.vue?vue&type=template&id=c457c3c0&scoped=true"
import script from "./zoneSideMenu.vue?vue&type=script&lang=js"
export * from "./zoneSideMenu.vue?vue&type=script&lang=js"
import style0 from "./zoneSideMenu.vue?vue&type=style&index=0&id=c457c3c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c457c3c0",
  null
  
)

export default component.exports